export function productivityStatusChipClass(status) {
  if (status === 'APPROVED') return 'bg-emerald-100 text-emerald-700'
  if (status === 'REJECTED') return 'bg-error-container text-error'
  return 'bg-primary-fixed text-primary'
}

export function formatApprovalDateTime(value) {
  if (!value) return 'N/A'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return 'N/A'
  return date.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function formatNamedCode(name, code) {
  if (!name && !code) return 'N/A'
  if (name && code) return `${name} (${code})`
  return name || code
}
